






































































































































































































































































import type Server from '@tridoc/frontend'
import { Component, Prop, Vue } from 'vue-property-decorator'
import TagAdder from '@/components/TagAdder.vue'
import CommentsList from '@/components/CommentsList.vue'
import pdfvuer from 'pdfvuer'

import { inspect } from 'util'

const validateUrl = (string = '') => {
  if (!string.startsWith('http://') || !string.startsWith('https://')) {
    string = 'https://' + string
  }
  try {
    const url = new URL(string);
    return url.href.replace(/\/$/, '')
  } catch (_) {
    return false
  }
}

@Component({
  components: {
    pdf: pdfvuer,
    TagAdder,
    CommentsList,
  }
})
export default class DocumentDetails extends Vue {
  @Prop() id!: string;
  meta: tdDocMeta | null = null
  loadingMeta = false
  page = 1
  numPages = 0
  pdfdata = undefined as undefined|Promise<any>
  error: false | any = false
  scale = 'page-width' as string | number
  loading = 0
  resize = true
  downloading = false

  dialog = {
    open: false,
    url: '',
    pw: '',
    valid: false,
    urlRules: [
      v => !!v || 'URL is required',
      v => {
        const temp = validateUrl(v)
        if (temp) {
          return true
        }
        return 'URL has to be valid'
      },
    ] as FormRule[],
    pwRules: [
      v => !!v || 'Password is required',
    ] as FormRule[],
  }

  pdfsrc () {
    if (this.meta) {
      return {
        url: ((this.$store.getters.server.url.startsWith('https://') || this.$store.getters.server.url.startsWith('http://')) ? this.$store.getters.server.url : 'https://' + this.$store.getters.server.url) + '/doc/' + this.id,
        httpHeaders: { Authorization: this.$store.getters.server.server.headers.get('Authorization') }
      }
    }
  }

  download () {
    if (!this.meta) return;
    this.downloading = true
    const url = ((this.$store.getters.server.url.startsWith('https://') || this.$store.getters.server.url.startsWith('http://')) ? this.$store.getters.server.url : 'https://' + this.$store.getters.server.url) + '/doc/' + this.id
    const options = {
      headers: {
        Authorization: this.$store.getters.server.server.headers.get('Authorization')
      }
    }
    fetch(url, options)
      .then(r => r.blob())
      .then(b => {
        this.downloading = false
        const link = document.createElement('a')
        link.href = URL.createObjectURL(b)
        link.download = this.meta?.title || this.id
        link.click();
      })
  }

  deleteDocument (identifier: string) {
    if (confirm('Are you sure you want to delete this Document?')) {
      const cs = this.$store.getters.server.server as Server
      if (cs && this.meta) {
        cs.deleteDocument(identifier)
          .then(r => {
            if ('error' in r) {
              alert(inspect(r))
            } else {
              this.$router.go(-1)
            }
          })
      }
    }
  }

  updateTitle () {
    const cs = this.$store.getters.server.server as Server
    if (cs && this.meta) {
      cs.setDocumentTitle(this.id, this.meta.title || '')
    }
  }

  loadingChange () {
    const cv = document.getElementsByTagName('canvas')
    this.loading = cv.length
    for (let i = 0; i < cv.length; i++) {
      cv[i].classList.add('elevation-4')
    }
  }

  scaleDown () {
    this.resize = false
    this.scale = Math.round(parseFloat('' + this.scale) * 20) / 20
    if (this.scale > 0.15) {
      this.scale = (this.scale - 0.05)
    } else {
      this.scale = 0.1
    }
  }

  scaleUp () {
    this.resize = false
    this.scale = Math.round(parseFloat('' + this.scale) * 20) / 20
    if (this.scale < 1.95) {
      this.scale = (this.scale + 0.05)
    } else {
      this.scale = 2
    }
  }

  scaleOff () {
    this.scale = 'page-width'
    this.resize = true
  }

  getScale () {
    return parseInt('' + (+this.scale * 100))
  }

  setScale (v: number) {
    this.resize = false
    this.scale = v / 100
  }

  getPdf () {
    const url = (
      (this.$store.getters.server.url.startsWith('https://') || this.$store.getters.server.url.startsWith('http://'))
        ? this.$store.getters.server.url : 'https://' + this.$store.getters.server.url) + '/doc/' + this.id
    this.pdfdata = pdfvuer.createLoadingTask({ url, httpHeaders: { Authorization: this.$store.getters.server.server.headers.get('Authorization') } });
    (this.pdfdata as Promise<any>).then(pdf => {
      this.numPages = pdf.numPages;
    }).catch(e => { this.error = e });
  }

  mounted () {
    if (this.$route.query.s) {
      this.$store.commit('selectServer', { url: this.$route.query.s })
    }
    if (!this.$store.getters.server) {
      const s = this.$route.query.s ? (Array.isArray(this.$route.query.s) ? this.$route.query.s[0] || '' : this.$route.query.s) : ''
      this.dialog.open = true;
      this.dialog.url = s
    } else {
      this.finishSetup()
    }
  }

  closeDialog () {
    this.$store.commit('selectServer', { url: this.dialog.url, password: this.dialog.pw })
    this.finishSetup()
  }

  finishSetup () {
    this.loadingMeta = true
    const cs = this.$store.getters.server?.server as Server
    if (cs) {
      cs.getMeta(this.id).then(r => {
        this.loadingMeta = false
        if ('error' in r) {
          this.error = r
          this.dialog.url = this.$route.query.s ? (Array.isArray(this.$route.query.s) ? this.$route.query.s[0] || '' : this.$route.query.s) : ''
          this.dialog.open = true
        } else {
          this.dialog.open = false
          this.meta = r
        }
      })
    }
    this.getPdf()
  }

  reloadTags () {
    this.loadingMeta = true
    const cs = this.$store.getters.server?.server as Server
    if (cs) {
      cs.getTags(this.id).then(r => {
        this.loadingMeta = false
        if (!('error' in r) && this.meta) {
          // We're being lenient with errors here as nothing much hinges on this
          this.meta.tags = r
        }
      })
    }
  }
}
